import { __extends } from "tslib";
import { ASObject } from '@awayfl/avm2';
// Class: GameInputControlType
var GameInputControlType = /** @class */ (function (_super) {
    __extends(GameInputControlType, _super);
    function GameInputControlType() {
        return _super.call(this) || this;
    }
    // Called whenever the class is initialized.
    GameInputControlType.classInitializer = null;
    // List of static symbols to link.
    GameInputControlType.classSymbols = null; // [];
    // List of instance symbols to link.
    GameInputControlType.instanceSymbols = null; // [];
    GameInputControlType.MOVEMENT = 'movement';
    GameInputControlType.ROTATION = 'rotation';
    GameInputControlType.DIRECTION = 'direction';
    GameInputControlType.ACCELERATION = 'acceleration';
    GameInputControlType.BUTTON = 'button';
    GameInputControlType.TRIGGER = 'trigger';
    return GameInputControlType;
}(ASObject));
export { GameInputControlType };
